import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { createWorkerCategory } from './WorkersAPI.jsx';

export default function AddExtraWorkCategory({ show, onHide, jwt, onCreated }) {

    const [name, setName] = useState('');

    const onSubmit = async () => {

        const response = await createWorkerCategory(jwt, name);

        if (response) {
            onCreated(response);
            onHide();
        }
        else alert('Не удалось создать, разрыв с сервером')
    }

    return <Modal
        centered
        show={show}
        onHide={onHide}
    >
        <Form onSubmit={e => e.preventDefault() || onSubmit()}>
            <Modal.Header closeButton>
                <Modal.Title>Новая категория</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-3">
                    <Form.Label>Название</Form.Label>
                    <Form.Control
                        required
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => onHide()}><span>Закрыть</span></Button>
                <Button variant="success" type="submit"><span>Создать</span></Button>
            </Modal.Footer>
        </Form>
    </Modal>
}
